import { render, staticRenderFns } from "./FileDrop.vue?vue&type=template&id=b95e5a3c&"
import script from "./FileDrop.vue?vue&type=script&lang=js&"
export * from "./FileDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports